import React from "react"
import Media from "react-media"
import { withRouter } from 'react-router-dom'

import LeftSide from 'components/molecules/access_left_side'
import OutlineButton from 'components/atoms/buttons/outline'
import { RightDiv } from './styled'
import * as routes from 'constants/routes'
 
class IncompleteTypeDecision extends React.Component {
    constructor(props){
        super(props)
        this.onUserTypeClick = this.onUserTypeClick.bind(this)
        this.onArtistTypeClick = this.onArtistTypeClick.bind(this)
    }

    onUserTypeClick(){
        this.props.history.push(routes.INCOMPLETE_USER_RECORD_AS_CLIENT)
    }

    onArtistTypeClick(){
        this.props.history.push(routes.INCOMPLETE_USER_RECORD_AS_ARTIST)
    }

    render() {
        return (
            <div className='d-flex'>
                <Media query={{ minWidth: 768 }}>
                    {matches =>
                        matches ? (
                        <LeftSide title='Completa tu registro'/>
                        ) : (
                        ''
                        )
                    }
                </Media>
                <RightDiv className='flex-fill d-flex flex-column justify-content-center align-items-center'>
                    <h4 className='mb-5'>¿Qué tipo de usuario quieres ser?</h4>
                    <OutlineButton text='Cliente' onClick={this.onUserTypeClick}/>
                    <OutlineButton text='Artista' onClick={this.onArtistTypeClick}/>
                </RightDiv>
            </div>
        )
    }
}

export default withRouter(IncompleteTypeDecision)